import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Public, token-less self-registration pages: an idle "logout" there would
// only wipe what a visitor is typing and bounce them to the sign-in page.
const IDLE_EXEMPT_PUBLIC_PATH = /\/(register|set-password)(\/|$)/;

const InactivityHandler = ({ children }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const logoutUser = () => {
    if (
      !localStorage.getItem('accessToken') &&
      IDLE_EXEMPT_PUBLIC_PATH.test(window.location.pathname)
    ) {
      return;
    }
    localStorage.clear();
    navigate('/');
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logoutUser, 15 * 60 * 1000); // 15 minutes
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    for (let event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer();

    return () => {
      for (let event of events) {
        window.removeEventListener(event, resetTimer);
      }
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return <>{children}</>;
};

export default InactivityHandler;
